/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useFormik } from "formik";
import { IStoreState, useAppDispatch, useAppSelector } from "../../../redux";
import { useNavigate, useParams } from "react-router-dom";
import { ControlledCustomSelect, OutlinedPasswordField, OutlinedTextField } from "../../../Components/formComponents";
import { PageLoader } from "../../../Components/PageLoader/PageLoader";
import { LoadState } from "../../../constants/enum";
import { clearSinglePaymentGatewaySync, fetchSinglePaymentGatewayAsync, IPaymentGateway, upsertSinglePaymentGatewayAsync } from "../../../redux/settings";
import { useOutletContext } from "../../../providers";
import { appNabarRoutes } from "../../../router/AppNavbarRoutes";
import { StandardCard } from "../../../Components/Card";

export const SinglePaymmentGatewayForm = () => {
    const { uuid: payment_gateway_uuid } = useParams<{ uuid?: string }>();
    const theme = useTheme()
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext();
    const { data: singlePaymentGateway, loading } = useAppSelector((storeState: IStoreState) => storeState.settings.paymentGateway.single_payment_gateway);

    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

    const {
        values,
        errors,
        isSubmitting,
        setSubmitting,
        setFieldValue,
        setValues,
        handleChange,
        handleSubmit,
    } = useFormik({
        initialValues: {
            ...singlePaymentGateway,
            ...(!singlePaymentGateway.outlet_uuid && {
                outlet_uuid, outlet_name
            })
        },
        validate: (values) => {
            const errors: any = {};
            if (!values.payment_gateway) {
                errors.payment_gateway = "*This is required field";
            }
            if (!values.website_base_url) {
                errors.website_base_url = "*This is required field";
            }
            if (!values.webhook_secret_key) {
                errors.webhook_secret_key = "*This is required field";
            }
            if (!values.gateway_secret_key) {
                errors.gateway_secret_key = "*This is required field";
            }
            return errors;
        },
        onSubmit: (values) => {
            dispatch(
                upsertSinglePaymentGatewayAsync({
                    payload: {
                        ...values,
                        ...(!values.payment_gateway_uuid && !outlet_uuid && {
                            outlet_uuid, outlet_name
                        })
                    } as IPaymentGateway,
                    onCallback(isSuccess, response) {
                        if (isSuccess) {
                            navigate(appNabarRoutes.settings.paymentGateway)
                        }
                    }
                }),
            ).finally(() => {
                setSubmitting(false);
            });
        },
    });


    React.useEffect(() => {
        if (!payment_gateway_uuid) return
        dispatch(fetchSinglePaymentGatewayAsync(payment_gateway_uuid));
    }, [payment_gateway_uuid]);

    React.useEffect(() => {
        setValues({
            ...singlePaymentGateway,
            ...(!outlet_uuid && {
                outlet_uuid, outlet_name
            })
        });
    }, [singlePaymentGateway]);

    React.useEffect(() => {
        return () => {
            dispatch(clearSinglePaymentGatewaySync())
        }
    }, []);
    console.log("outlet_details ==>", outlet_uuid)

    return (
        <PageLoader loading={LoadState.pending === loading}>
            <Typography variant='h2' fontSize={18}>Payment Gateway information</Typography>
            <StandardCard sx={{ mt: 2 }}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} py={2}>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }

                                    variant='h2'>Payment Gateway Name</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <ControlledCustomSelect
                                    name="payment_gateway"
                                    fullWidth
                                    options={[
                                        { label: "Stripe", value: "STRIPE" }
                                    ]}
                                    placeholder="select payment gateway"
                                    value={values.payment_gateway}
                                    onChange={handleChange}
                                    error={errors.payment_gateway}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Website Url</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <OutlinedTextField
                                    // label="Website Url"
                                    id="website_base_url"
                                    value={values.website_base_url}
                                    onChange={handleChange}
                                    error={errors.website_base_url}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Gateway Secret Key</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <OutlinedPasswordField
                                    // label="Gateway Secret Key"
                                    id="gateway_secret_key"
                                    value={values.gateway_secret_key}
                                    onChange={handleChange}
                                    error={errors.gateway_secret_key}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Webhook Secret Key</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <OutlinedPasswordField
                                    // label="Webhook Secret Key"
                                    id="webhook_secret_key"
                                    value={values.webhook_secret_key}
                                    onChange={handleChange}
                                    error={errors.webhook_secret_key}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Payment Success Redirect Url</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <OutlinedTextField
                                    // label="Payment Success Redirect Url"
                                    id="payment_success_url"
                                    value={values.payment_success_url}
                                    onChange={handleChange}
                                    error={errors.payment_success_url}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Payment Failed Redirect Url</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <OutlinedTextField
                                    // label="Payment Failed Redirect Url"
                                    id="payment_failed_url"
                                    value={values.payment_failed_url}
                                    onChange={handleChange}
                                    error={errors.payment_failed_url}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            <Grid item xs={12} md={3} >
                                <Typography
                                    sx={isMobileView ?
                                        { textAlign: "left", mb: -1.5 }
                                        : { textAlign: "right", mt: 1 }
                                    }
                                    variant='h2'>Status</Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <ControlledCustomSelect
                                    // label="Status"
                                    name="status"
                                    fullWidth
                                    options={[
                                        { label: "Active", value: "ACTIVE" },
                                        { label: "In Active", value: "INACTIVE" }
                                    ]}
                                    placeholder="select status"
                                    value={values.status}
                                    onChange={handleChange}
                                    error={errors.status}
                                />
                            </Grid>
                            {!isMobileView && <Grid item xs={12} md={4} />}
                        </>
                        <>
                            {!isMobileView && <Grid item xs={12} md={3} />}
                            <Grid item xs={12} md={5} >
                                <Button
                                    sx={{ width: "10%", border: "1px solid" }}
                                    disabled={isSubmitting}
                                    variant="contained"
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </Grid>
                        </>
                    </Grid>
                </form>
            </StandardCard>
        </PageLoader>
    );
};
